'use client';

import { __assign } from '../../_virtual/_tslib.js';
import React__default, { useState } from 'react';
import Input from '../../Input/index.js';
import { t } from '../../Utils/helpers.js';
import styles from '../JobAlert.module.scss.js';

var JobTitle = function (props) {
    var _a = props.jobTitle, jobTitle = _a === void 0 ? '' : _a, _b = props.isValidate, isValidate = _b === void 0 ? true : _b, _c = props.language, language = _c === void 0 ? 'en' : _c, setJobTitle = props.setJobTitle, shortForm = props.shortForm;
    var _d = useState(isValidate), isFieldValidate = _d[0], setValidate = _d[1];
    var handleOnChangeValue = function (value) {
        setValidate(value.length > 0);
        setJobTitle && setJobTitle(value);
    };
    return (React__default.createElement(React__default.Fragment, null,
        shortForm ? (React__default.createElement("label", { htmlFor: 'jobTitle' },
            t('Job title', language),
            " ",
            React__default.createElement("span", { style: { color: '#DC362E' } }, "*")))
            : (React__default.createElement("label", { htmlFor: 'jobTitle' },
                t('Job title', language),
                " ",
                React__default.createElement("span", null,
                    "(",
                    t('Required', language),
                    ")"))),
        React__default.createElement(Input, { type: 'text', id: 'jobTitle', isRequired: true, onChange: function (value) { return handleOnChangeValue(value); }, value: jobTitle !== null && jobTitle !== void 0 ? jobTitle : '', className: styles.jobAlertInput, maxLength: 100, placeholder: t('Enter job title', language), autoFocus: true, onBlur: function (e) {
                setTimeout(function () {
                    setValidate(e.target.value.length > 0);
                }, 0);
            }, hasError: !isFieldValidate }),
        React__default.createElement("p", __assign({ className: "error-message ".concat(styles.errorMessage) }, (isFieldValidate ? { hidden: true } : '')), t('This field is required', language))));
};

export { JobTitle as default };
//# sourceMappingURL=index.js.map
